import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import DashboardFeatureDetails from "../pages/Dashboard/components/DashboardFeatureDetails";

function EnrollmentSummaryPopup(props) {
  const { show, setShow, enrollmentSummaryData } = props;
  const navigate = useNavigate();

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div className="hospital_modal_main_wrapper">
      <Modal {...props} show={show} backdrop="static" keyboard={false} centered>
        <Modal.Header className="leave_employee_modal">
          <button variant="secondary" onClick={handleClose}>
            x
          </button>
        </Modal.Header>
        <Modal.Body className="leave_employee_modal">
          <div className="leave_employee_form-wrapper">
            <h5 className="text-center">Enrollment Summary</h5>
            <DashboardFeatureDetails
              enrollmentSummaryData={enrollmentSummaryData}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default EnrollmentSummaryPopup;
